const BASE_URL = `${process.env.REACT_APP_MAIN_WEBSITE_URL}stocks/`;
const GLOSSARY_URL = `${process.env.REACT_APP_MAIN_WEBSITE_URL}jainam-glossary/`;

export const socialMediaLinks = [
  {
    href: "https://www.whatsapp.com/channel/0029VaRsaCQADTOExWHp4Q2w",
    src: "footer-images/whatsapp.svg",
    alt: "WhatsApp",
  },
  {
    href: "https://t.me/jainamresearch",
    src: "footer-images/telegram.svg",
    alt: "Telegram",
  },
  {
    href: "https://www.instagram.com/jainambroking/",
    src: "footer-images/instagram.svg",
    alt: "Instagram",
  },
  {
    href: "https://twitter.com/JAINAM_BROKING",
    src: "footer-images/twitter.svg",
    alt: "Twitter",
  },
  {
    href: "https://www.facebook.com/JainamBroking/",
    src: "footer-images/facebook.svg",
    alt: "Facebook",
  },
  {
    href: "https://in.linkedin.com/jainamresearch",
    src: "footer-images/linkedin.svg",
    alt: "LinkedIn",
  },
  {
    href: "https://www.youtube.com/channel/UC0_oYkIz8neLnVIjOuKgeSw",
    src: "footer-images/youtube.svg",
    alt: "YouTube",
  },
];

export const footerColumns = [
  {
    title: "PRODUCTS",
    links: [
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}product/jainam/`, text: "Jainam" },
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}product/jplus/`, text: "Jainam Assist" },
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}product/jainam-api/`, text: "API" },
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}product/jainam-strike/`, text: "Strike" },
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}product/smartgreek/`, text: "SmartGreek" },
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}product/smart-rms/`, text: "SmartRMS" },
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}product/smart-delta/`, text: "SmartDelta" },
      {
        href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}product/jainam-pro-2-0/`,
        text: "Jainam Pro 2.0",
      },
    ],
  },
  {
    title: "INVESTMENT OPTIONS",
    links: [
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}stocks/`, text: "Stocks" },
      {
        href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}margin-trading-facility/`,
        text: "Margin Trading Facility",
      },
      {
        href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}options-trading/`,
        text: "Options Trading",
      },
      {
        href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}futures-trading/`,
        text: "Futures Trading",
      },
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}mutual-funds/`, text: "Mutual Funds" },
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}nfo/`, text: "NFO" },
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}debt/`, text: "Debt Products" },
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}ipo/`, text: "IPO" },
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}pms/`, text: "PMS" },
    ],
  },
  {
    title: "COMMUNITY",
    links: [
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}glossary/`, text: "Glossary" },
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}blog/`, text: "Blogs" },
      { href: "https://support.jainam.in/", text: "FAQs" },
      {
        href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}indian-options-conclave-7-0/`,
        text: "Indian Options Conclave 7.0",
      },
      {
        href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}contact-us/#jbl-branches`,
        text: "Branches",
      },
    ],
    subSections: [
      {
        title: "PARTNER WITH US",
        links: [
          {
            href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}partner-with-us/`,
            text: "Authorized Person",
          },
          {
            href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}authorized-person-details/`,
            text: "Authorized Person Details",
          },
        ],
      },
    ],
  },
  {
    title: "QUICK LINKS",
    links: [
      {
        href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}open-demat-account/`,
        text: "Open Demat Account",
      },
      {
        href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}investor-charter/`,
        text: "Investor Charter",
      },
      {
        href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}investor-corner/`,
        text: "Investor Corner",
      },
      {
        href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}details-of-complaint/`,
        text: "Details of Complaint",
      },
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}useful-links/`, text: "Useful Links" },
      { href: "https://pledge.cvc.nic.in", text: "Vigilance Pledge" },
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}forms/`, text: "Downloads" },
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}sitemap/`, text: "Sitemap" },
      {
        href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}wp-content/uploads/2026/09/QR-Code.pdf`,
        text: "PMS UPI Handle",
      },
    ],
  },
  {
    title: "COMPANY",
    links: [
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}about-us/`, text: "About" },
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}pricing/`, text: "Pricing" },
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}career/`, text: "Careers" },
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}contact-us/`, text: "Contact Us" },
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}disclosures/`, text: "Disclosures" },
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}policies/`, text: "Policies" },
    ],
  },
  {
    title: "Important Information",
    links: [
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}disclaimer/`, text: "Disclaimer" },
      { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}privacy-policy/`, text: "Privacy policy" },
      {
        href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}terms-conditions/`,
        text: "Terms & Conditions",
      },
      {
        href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}contact-us/#tab2`,
        text: "Grievance and complaints",
      },
      {
        href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}investor-safety/`,
        text: "Investor Safety",
      },
      {
        href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}cancellation-and-refund-policy/`,
        text: "Cancellation And Refund Policy",
      },
    ],
  },
];

export const marketScreenerShareMarket = [
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}large-cap-stocks/`, text: "Large Cap Stocks" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}mid-cap-stocks/`, text: "Mid Cap Stocks" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}small-cap-stocks/`, text: "Small Cap Stocks" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}top-gainers/`, text: "Top Gainers" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}top-losers/`, text: "Top Losers" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}penny-stocks/`, text: "Penny Stocks" },
];

export const marketScreenerIPO = [
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}upcoming-ipo/`, text: "Upcoming IPO" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}upcoming-sme-ipo/`, text: "Upcoming SME IPO" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}ongoing-ipo/`, text: "Ongoing IPO" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}ongoing-sme-ipo/`, text: "Ongoing SME IPO" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}closed-ipo/`, text: "Closed IPO" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}closed-sme-ipo/`, text: "Closed SME IPO" },
  // {
  //   href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}recently-listed-ipo/`,
  //   text: "Recently Listed IPO",
  // },
  // {
  //   href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}recently-listed-sme-ipo/`,
  //   text: "Recently Listed SME IPO",
  // },
  // {
  //   href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}sme-ipo-calendar/april-2025/`,
  //   text: "SME IPO Calendar",
  // },
  // {
  //   href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}ipo-calendar/april-2025/`,
  //   text: "IPO Calendar",
  // },
];

export const LETTERS = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i));
export const LOWERCASE_LETTERS = Array.from({ length: 26 }, (_, i) => String.fromCharCode(97 + i));

export const SPECIAL_GROUPS = ["0-9"];

export const FILTER_KEYS = [...LETTERS, ...SPECIAL_GROUPS];
export const LOWERCASE_FILTER_KEYS = [...LOWERCASE_LETTERS, ...SPECIAL_GROUPS];

export const getStocksListUrl = (key: string): string => `${BASE_URL}letter-${key}`;
export const getGlossaryUrl = (key: string): string => `${GLOSSARY_URL}#${key.toUpperCase()}`;
export const importantInformation = [
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}disclaimer/`, text: "Disclaimer" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}privacy-policy/`, text: "Privacy Policy" },
  {
    href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}terms-conditions/`,
    text: "Terms & Conditions",
  },
  {
    href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}contact-us/#tab2`,
    text: "Grievances and Complaints",
  },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}investor-safety/`, text: "Investor Safety" },
];

export const toolsLinks = [
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}calculators/`, text: "All Calculators" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}emi-calculator/`, text: "EMI Calculator" },
  {
    href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}personal-loan-emi-calculator/`,
    text: "Personal Loan EMI Calculator",
  },
  {
    href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}gold-loan-calculator/`,
    text: "Gold Loan Calculator",
  },
  {
    href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}bike-loan-emi-calculator/`,
    text: "Bike Loan EMI Calculator",
  },
  {
    href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}car-loan-emi-calculator/`,
    text: "Car Loan EMI Calculator",
  },
  {
    href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}home-loan-emi-calculator/`,
    text: "Home Loan EMI Calculator",
  },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}mtf-calculator/`, text: "MTF Calculator" },
  {
    href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}simple-interest-calculator/`,
    text: "Simple Interest Calculator",
  },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}ppf-calculator/`, text: "PPF Calculator" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}fd-calculator/`, text: "FD Calculator" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}hra-calculator/`, text: "HRA Calculator" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}nsc-calculator/`, text: "NSC Calculator" },
  {
    href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}inflation-calculator/`,
    text: "Inflation Calculator",
  },
  {
    href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}sukanya-samriddhi-yojana-calculator/`,
    text: "Sukanya Samriddhi Yojana Calculator",
  },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}rd-calculator/`, text: "RD Calculator" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}swp-calculator/`, text: "SWP Calculator" },
  {
    href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}compound-interest-calculator/`,
    text: "Compound Interest Calculator",
  },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}apy-calculator/`, text: "APY Calculator" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}sip-calculator/`, text: "SIP Calculator" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}nps-calculator/`, text: "NPS Calculator" },
  {
    href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}step-up-sip-calculator/`,
    text: "Step Up SIP Calculator",
  },
  {
    href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}margin-calculator/`,
    text: "Margin Calculator",
  },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}cagr-calculator/`, text: "CAGR Calculator" },
  {
    href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}gratuity-calculator/`,
    text: "Gratuity Calculator",
  },
  {
    href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}retirement-calculator/`,
    text: "Retirement Calculator",
  },
  {
    href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}pms/#how-can-i-calculate-my-fixed-fees`,
    text: "PMS Fee Calculator",
  },
];

export const sliderData = [
  {
    title: "Jainam IFSC Mavens Private Limited (CIN: U65990GJ2017PTC097096)",
    description: `
      Unit-235, 2 Floor, Signature Tower, Block - 13, Road 1C, Zone-1, GIFT SEZ, GIFT City, Gandhinagar, Gujarat – 382050 | Corporate Office: Jainam House, Plot No. 42, Near Shardayatan School, Piplod, Surat, Gujarat – 395007 | SEBI Registration No.: INZ000179836 | Member: NSE IFSC Limited - Trading ID: 10036
    `,
  },
  {
    title:
      "Jainam Broking Limited (Erstwhile Jainam Share Consultants Private Limited) (CIN: U67120GJ2003PLC043162)",
    description: `
      P03-02 C / D / E, 3rd Floor, WTC Tower (51A), Road 5E, Block 51, Zone 5, DTA, 
      GIFT City, Gandhinagar, Gujarat – 382050 | Corporate Office: Jainam House, Plot 
      No. 42, Near Shardayatan School, Piplod, Surat, Gujarat – 395007 | Tel No.: 0261 6725555 / 2305555 | 
      Website: www.jainam.in | SEBI Registration No.: INZ000198735 Member: NSE - Trading ID: 12169 | 
      BSE - Trading ID: 2001 | MCX - Trading ID: 56670 | NCDEX - Trading ID: F01297 | 
      CDSL Depository through Jainam Broking Limited : CDSL SEBI Regn No.: IN-DP-CDSL-223-2016 - DP ID: 041500 
      Dated: 15 December 2005 | Research Analyst: INH000006448 | PMS Regn: INP000006785 | 
      ARN: 39208 AMFI-Registered Mutual Fund Distributor, Since 21-05-2006. Valid Upto: 25-09-2029
    `,
  },
  {
    title: "Jainam Commodities Private Limited (CIN: U51100GJ2005PTC046161)",
    description: `
      M-11, Malhar Complex, Dumas Road, Surat, Gujarat – 395007 | Corporate Office: Jainam House, Plot No. 42, Near Shardayatan School, Piplod, Surat, Gujarat – 395007 | Tel No.: 0261 6725555 / 2305555 | Website: www.jainam.in | SEBI Registration No.: INZ000091934 | Member: NCDEX - Trading ID: 00738
    `,
  },
];

export const footerDataLine = [
  {
    content: `The securities listed on this website are examples only, and not recommendations.`,
  },
];
export const footerData = [
  {
    content: `<p>Investments in securities market are subject to market risks, read all the related documents carefully before investing. Jainam is a registered Mutual Fund Distributor/s for Mutual Fund products. For more details visit: <a style="color: #1a6e69; font-family: in_semi;" href="https://www.jainam.in/disclaimer">jainam.in/disclaimer</a></p>`,
  },
  {
    content: `<p>Customers having any queries, feedback, or requests for clarification may write to
    <a style="color: #1a6e69; font-family: in_semi;" href="mailto:customer.care@jainam.in">customer.care@jainam.in</a></p>`,
  },
  {
    content: `<p>Customers having any grievances or complaints may write to  <a style="color: #1a6e69; font-family: in_semi;" href="mailto:grievance@jainam.in">grievance@jainam.in</a></p>`,
  },
  {
    content: `Jainam Broking Limited involves in proprietary trading alongside its clientele businesses`,
  },
  {
    content: `Jainam Commodities Private Limited is involved in proprietary trading with MCX & NCDEX in addition to clientele business..`,
  },
  {
    content: `Investors do not need to issue cheque while subscribing to an IPO. Bank account number and an application form authorizing your bank to make payment in case of allotment fulfills the requirement. No worries for refund as the money remains in investor's account.`,
  },
  {
    content: `<p>Procedure to file a complaint on SMART ODR: Register on <a href="https://smartodr.in/" style="color: #1a6e69; font-family: in_semi;">Smart ODR</a> portal. Mandatory details for filing complaints on SCORES: Name, PAN, Address, Mobile Number, E-mail ID. Benefits: Effective Communication, Speedy redressal of the grievances. SEBI Circular
<a href="https://www.sebi.gov.in/legal/circulars/jul-2023/online-resolution-of-disputes-in-the-indian-securities-market_74794.html" style="color: #1a6e69; font-family: in_semi;" target="__blank">SEBI/HO/OIAE/OIAE_IAD-1/P/CIR/2023/135</a> dated July 31, 2023.</p>`,
  },
  {
    content: `Procedure to file a complaint on <a href="https://scores.sebi.gov.in/" style="color: #1a6e69; font-family: in_semi;">SEBI SCORES</a>: Register on SCORES portal. Mandatory details for filing complaints on SCORES: Name, PAN, Address, Mobile Number, E-mail ID. Benefits: Effective Communication, Speedy redressal of the grievances.`,
  },
  {
    content: `Please ensure that you carefully read the Risk Disclosure Document as prescribed by SEBI, our Terms &amp; Conditions and Privacy Policy.`,
  },
  {
    content: `Prevent Unauthorized Transactions in your Demat account - Update your mobile number with your depository participant. Receive alerts on your registered mobile for all the transactions in your account directly from CDSL on the same day. Issued in interest of investors.`,
  },
  {
    content: `Valued clients and investors, please be warned about fraudulent investment schemes being circulated. These scams often promise high returns with little to no risk. If they falsely claim to be from Jainam Broking Limited or our partners, kindly ignore the same.`,
  },
  {
    content: `KYC is one time exercise while dealing in securities market - once the KYC is done through a SEBI registered intermediary (Broker, DP, Mutual Fund etc.), Investor does not need to repeat the procedure when he/she approaches another intermediary.`,
  },
  {
    content: `<p>Attention Investors (1) Stock Brokers can accept securities as margin from clients only by way of pledge in the depository system w.e.f. September 1, 2020. (2) Update your mobile number &amp; Email ID with your stock broker / depository participant and receive OTP directly from depository on your email ID and/or mobile number to create pledge. (3) Pay 20% upfront margin of the transaction value to trade in cash market segment. (4) Investors may please refer to the Exchange's Frequently Asked Questions (FAQs) issued vide circular reference NSE/INSP/45191 dated July 31, 2020 and NSE/INSP/45534 dated August 31, 2020 and other guidelines issued from time to time in this regard. (5) Check your Securities / MF / Bonds in the consolidated account statement issued by NSDL/CDSL every month.(6) Pursuant to SEBI/HO/MIRSD/FATF/P/CIR/2023/0144 dated August 11, 2023, NSE/ISC/57977 dated August 16, 2023, NSE/ISC/58027 dated August 18, 2023, NSE/ISC/58200 dated September 02, 2023, NSE/ISC/59051 dated October 23, 2023, NSE/ISC/60600 dated February 07, 2024, NSE/ISC/61100 dated March 13, 2024 and NSE/ISC/61553 dated April 10, 2024 on “Simplification of KYC process and rationalisation of Risk Management Framework at KYC (Know Your Client) Registration Agencies (KRAs)” and “Guidelines in pursuance of amendment to SEBI KYC (Know Your client) Registration Agency (KRA) Regulations, 2011, it is hereby informed that the clients whose KYC are not found to be validated by KRAs i.e. where the KYCs are “On Hold” for any reasons (both AADHAAR and Non-AADHAAR based OVD) uploaded to the KRA from April 01, 2024 to May 31, 2024 shall neither be Permitted to Trade on the Exchange, nor will they be allowed to square up their open positions, if any, w.e.f. June 29, 2024 until they comply with the validation requirements. Eventually, such open positions will naturally expire on the expiry date of the respective contract. - <a style="color: #1a6e69; font-family: in_semi;" href="https://www.jainam.in/wp-content/uploads/2024/12/NSE-Circular.pdf" target="_blank">CIRCULAR</a> Disaggregated collateral information on web-based facility available at: <a style="color: #1a6e69; font-family: in_semi;" href="https://bseplus.bseindia.com/" target="_blank">BSE Plus</a>, <a style="color: #1a6e69; font-family: in_semi;" href="https://www.bseindia.com/Downloads/MediaRelease/PR18022026_20261802.pdf" target="_blank"> Media releases by BSE regarding unauthorized activities carried out by entities.</a><a style="color: #1a6e69; font-family: in_semi;"href="https://login.irra.live/stocks/jsp/irra/" target="_blank"> Access to the IRRA Platform.</a>
    SEBI presents Samajh Se Investing Simple: Understand Before You Invest, Choose Regulated Investment Products, Start Early, Stay Invested, Beware of Investment Frauds.
</p>`,
  },
];

export const holidayLinks = [
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}nse-holidays/`, text: "NSE Holidays" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}bse-holidays/`, text: "BSE Holidays" },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}mcx-holidays/`, text: "MCX Holidays" },
  {
    href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}clearing-or-settlement-holidays/`,
    text: "Clearing & Settlement holidays",
  },
  { href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}muhurat-trading/`, text: "Muhurat Trading" },
  {
    href: `${process.env.REACT_APP_MAIN_WEBSITE_URL}us-market-holidays/`,
    text: "US market holidays",
  },
];
